import { render, staticRenderFns } from "./CooperativeRegistration.vue?vue&type=template&id=797af56e&scoped=true&"
import script from "./CooperativeRegistration.vue?vue&type=script&lang=js&"
export * from "./CooperativeRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797af56e",
  null
  
)

export default component.exports